const smoothScroller = {
  /* istanbul ignore next */
  get windowPageYOffset() {
    return window.pageYOffset;
  },

  smoothScroll(el, duration = 500, options = {}) {
    const start = this.windowPageYOffset;
    let end;

    if (typeof el === 'number') {
      end = parseInt(el, 10);
    } else if (typeof el === 'string') {
      const element = window.document.querySelector(el);

      if (element) {
        end = this.getTopOfElement(element, options.offset);
      }
    } else {
      end = this.getTopOfElement(el, options.offset);
    }

    const startTimestamp = Date.now();

    const sixtyFPS = 1000 / 60;
    const timeout = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      function setTimeoutFallback(fn) {
        window.setTimeout(fn, sixtyFPS);
      };

    const step = () => {
      const elapsed = Date.now() - startTimestamp;
      const position = this.position(start, end, elapsed, duration);
      window.scroll(0, position);

      if (elapsed <= duration) {
        timeout(step);
      }
    };

    step();
  },

  getTopOfElement(element, offset = 0) {
    let top;
    if (element.nodeName === 'HTML') {
      top = -this.windowPageYOffset;
    } else {
      top = element.getBoundingClientRect().top + this.windowPageYOffset + offset;
    }

    return top;
  },

  easeInOutCubic(t) {
    return t < 0.5 ? (4 * t * t * t) : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },

  position(start, end, elapsed, duration) {
    return (elapsed > duration) ? end : start + (end - start) * this.easeInOutCubic(elapsed / duration);
  },

  isSupported() {
    return window && typeof this.windowPageYOffset === 'number' && window.history.pushState;
  },

  smoothScrollWrapper() {
    if (this.isSupported()) {
      this.smoothScroll(...arguments);
    }
  },

  scrollToElement(selector, duration, options) {
    const element = window.document.querySelector(selector);

    if (element) {
      this.smoothScrollWrapper(element, duration, options);
    }
  },

  scrollToTop(duration) {
    this.scrollToElement('body', duration);
  },

  scrollStraightToTop() {
    this.scrollToTop(0);
  },
};

export function scrollStraightToTop() {
  smoothScroller.scrollStraightToTop();
}

export default smoothScroller;



/** WEBPACK FOOTER **
 ** ./src/utils/smoothScroller.js
 **/